import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import breakpoints from "utils/breakpoints";
import useBreakpoint from "utils/hooks/useBreakpoint";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "tailwind.config.js";
import SaleCenterCommunityCardPanel from "components/components/molecules/SaleCenterCommunityCardPanel";

const fullConfig = resolveConfig(tailwindConfig);
const CardContainer = styled.div`
  margin-top: 0.313rem;
  margin-bottom: 0.25rem;
  @media ${breakpoints.md} {
    margin-bottom: 0.25rem;
  }
`;
const Card = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
  @media ${breakpoints.md} {
    margin-bottom: 1rem;
  }
`;
const AvailableFlag = styled.div`
  border-radius: 0.813rem;
  min-height: 1.625rem;
  width: fit-content;

  @media ${breakpoints.md} {
    ${({ islogo }) =>
      islogo
        ? ``
        : `${Card}:hover & {
      color: white;
      background-color: ${fullConfig.theme.colors["mattamy-blue-light"]};
    }`}
  }

  ${({ isMobile, islogo }) =>
    islogo ? `` : isMobile ? `min-width: 7.5rem;` : `min-width: 8rem;`}
`;
const CardTitle = styled.div`
  letter-spacing: -0.029rem;
`;
const Img = styled.img`
  min-height: 13.75rem;
  transition: transform 0.5s ease;

  @media ${breakpoints.md} {
    min-height: 18rem;
  }
`;
const ImageContainer = styled.div`
  @media ${breakpoints.md} {
    min-height: 18rem;
  }
`;

const SaleCenterCommunityCard = (props) => {
  const {
    city,
    state,
    communityName,
    direction,
    emailAddress,
    phone,
    saleCenterHours,
    zipCode,
    cardImage,
    openNow,
    flagText,
    firstCTAText,
    firstCTALink,
    secondCTAText,
    secondCTALink,
    latitude,
    longitude,
    page,
    counter,
    numberPerPage,
    salesCenterNoteVM,
    secondSalesCenters,
    gmbLink = {},
    title,
  } = props;
  const minCounter = (page - 1) * numberPerPage;
  const maxCounter = page * numberPerPage + 1;
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  const imageSrc =
    (cardImage && cardImage.srcDesktop) || (cardImage && cardImage.src);
 
  const renderSalesCenterInformation = (
    showContent = true,
    info = {},
    withoutPanel = false
  ) => {
    return (
      <SaleCenterCommunityCardPanel
        withoutPanel={withoutPanel}
        showContent={showContent}
        city={info.city}
        state={info.state}
        direction={info.direction}
        emailAddress={info.emailAddress}
        phone={info.phone}
        saleCenterHours={info.saleCenterHours}
        zipCode={info.zipCode}
        openNow={info.openNow}
        firstCTAText={info.firstCTAText}
        firstCTALink={info.firstCTALink}
        secondCTAText={info.secondCTAText}
        secondCTALink={info.secondCTALink}
        latitude={info.latitude}
        longitude={info.longitude}
        salesCenterNoteVM={info.salesCenterNoteVM}
        gmbLink={info.gmbLink}
        title={info.title}
      />
    );
  };
  return (
    <CardContainer
      className={minCounter < counter && maxCounter > counter ? "" : "hidden"}
    >
      <Card className="w-full bg-mattamy-white flex flex-col lg:flex-row justify-center items-start">
        <ImageContainer className="w-full h-full text-center relative rounded overflow-hidden md:w-4/12">
          <div className="overflow-hidden rounded">
            <Img
              src={imageSrc}
              alt={(cardImage && cardImage.alt) || ""}
              className={"bg-gray-300 object-cover w-full"}
            />
          </div>
        </ImageContainer>

        <div className="w-full h-full text-left md:w-8/12 flex flex-col">
          {flagText && (
            <div className="flex flex-row lg:pl-5 mb-4">
              <AvailableFlag
                isMobile={isMobile}
                islogo={false}
                className="flex items-center justify-center bg-white border-mattamy-blue-light border-2 border-mattamy-blue-light hover:md:bg-mattamy-blue-light
                mt-1 md:mt-0 hover:md:text-white text-mattamy-blue-light px-2"
              >
                <p className="px-1 text-center font-trade-gothic-20 uppercase text-sm tracking-wide leading-3 mt-1">
                  {flagText}
                </p>
              </AvailableFlag>
            </div>
          )}

          <CardTitle className="font-trade-gothic-20 text-mattamy-blue text-3xl leading-8 md:mt-1 block lg:pl-8">
            <h3 aria-label={communityName}>{communityName}</h3>
          </CardTitle>

          {renderSalesCenterInformation(
            true,
            {
              city,
              state,
              direction,
              emailAddress,
              phone,
              saleCenterHours,
              zipCode,
              openNow,
              firstCTAText,
              firstCTALink,
              secondCTAText,
              secondCTALink,
              latitude,
              longitude,
              salesCenterNoteVM,
              gmbLink,
              title,
            },
            !secondSalesCenters
          )}
          {secondSalesCenters &&
            renderSalesCenterInformation(false, secondSalesCenters)}
        </div>
      </Card>
    </CardContainer>
  );
};

SaleCenterCommunityCard.propTypes = {
  props: PropTypes.object,
};

export default SaleCenterCommunityCard;
